// extracted by mini-css-extract-plugin
export default {"typingEffectText":"TypingEffectText_typingEffectText__JJt3c"};